// extracted by mini-css-extract-plugin
export var li = "_vj-2";
export var ol = "_vj-1";
export var ul = "_vj-0";